"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.namedUuid = exports["default"] = void 0;
/* eslint-disable no-bitwise */
var uuid = function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};
var namedUuid = exports.namedUuid = function namedUuid() {
  var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return "".concat(className, "-").concat(uuid());
};
var _default = exports["default"] = uuid;